export interface SettleLoanDialogData {
  message: string;
  subMessage: string;
}

export interface SettleLoanDialogResult {
}
